import { render, staticRenderFns } from "./deviceFile.vue?vue&type=template&id=5b894358&scoped=true&"
import script from "./deviceFile.vue?vue&type=script&lang=js&"
export * from "./deviceFile.vue?vue&type=script&lang=js&"
import style0 from "./deviceFile.vue?vue&type=style&index=0&id=5b894358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b894358",
  null
  
)

export default component.exports